var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownpoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #66afeb;\n      }\n\n      .cls-2 {\n        fill: #9ec5fb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.87,26.5h0c-.52-.19-.78-.77-.59-1.29l1.37-3.83c.19-.52,.77-.78,1.29-.59h0c.52,.19,.78,.77,.59,1.29l-1.37,3.83c-.19,.52-.77,.78-1.29,.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.94,26.61h0c-.52-.18-.8-.75-.61-1.27l1.44-4.02c.18-.52,.75-.8,1.27-.61h0c.52,.18,.8,.75,.61,1.27l-1.44,4.02c-.18,.52-.75,.8-1.27,.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.92,26.61h0c-.52-.18-.8-.75-.61-1.27l1.44-4.02c.18-.52,.75-.8,1.27-.61h0c.52,.18,.8,.75,.61,1.27l-1.44,4.02c-.18,.52-.75,.8-1.27,.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.91,26.61h0c-.52-.18-.8-.75-.61-1.27l1.44-4.02c.18-.52,.75-.8,1.27-.61h0c.52,.18,.8,.75,.61,1.27l-1.44,4.02c-.18,.52-.75,.8-1.27,.61Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.19,10.63c-.37,0-.73,.07-1.07,.17,0-.06,0-.11,0-.17,0-4.36-3.54-7.9-7.9-7.9-3.68,0-6.77,2.53-7.65,5.94-.29-.05-.59-.09-.9-.09-2.75,0-4.98,2.23-4.98,4.98,0,2.47,1.82,4.66,4.18,5.05h.04s9.34,0,9.34,0c0,0,0,0,0,0s0,0,0,0h8.48c.2,0,.34,0,.45,0,2.19,0,3.94-1.82,3.94-4.01s-1.78-3.97-3.97-3.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownpoor);
export default __webpack_public_path__ + "static/media/downpoor.efe86f88a6b62db56c691bd34f7ac846.svg";
export { ForwardRef as ReactComponent };